module.exports = __webpack_public_path__ + "img/group25@2x-ja.0e87f7a4.png";